import React from 'react';
import { StyledContainer } from './GroupContainer.styles';

const GroupContainer = ({ children }) => <StyledContainer>{children}</StyledContainer>;

export default GroupContainer;
